'use client'

import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'
import { BaseActivityRefreshProvider } from './ActivityRefreshContext'

interface ConditionalActivityRefreshProviderProps {
  children: ReactNode
}

export function ActivityRefreshProvider({ children }: ConditionalActivityRefreshProviderProps) {
  const pathname = usePathname()

  // Only provide the context for dashboard routes
  const isDashboardRoute = pathname.startsWith('/dashboard')

  if (isDashboardRoute) {
    return <BaseActivityRefreshProvider>{children}</BaseActivityRefreshProvider>
  }

  return <>{children}</>
}
